import {
  getPrimeLeadList,
  getPrimeLeadHistory,
  getDashboardCounter,
  getPrimeNewLeadList,
  getPrimeAllocateListById,
  GetStaffByPid,
  getAllPrimeTrainingWebinar,
  getAllPrimeNotification,
  getAllPrimePoll,
  getPrimeMembershipFlowList,
  getPrimeMagazineList,
  GetAllPrimeMemberList,
  getPrimeSuggestionList,
  getAllLvbsessionPodcast,
  getAllPrimeGreeting,
  getPrimeMemberWelcomeKitHistory,
  getPrimeDashboardCounter,
  getAllCity,
  getAllState,
  getAllCountry
} from "src/api/commonapi";

export async function fetchNewLeadList(data) {
  try {
    const resp = await getPrimeNewLeadList(data);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchleadlistbyid(u_id, u_type) {
  try {
    const resp = await getPrimeLeadList(u_id, u_type);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchPrimeleadhistory(l_id) {
  try {
    const resp = await getPrimeLeadHistory(l_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchallocatelistbyid(u_id, u_type) {
  try {
    const resp = await getPrimeAllocateListById(u_id, u_type);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchdashboardcounter(u_id, u_type, city_id) {
  try {
    const resp = await getDashboardCounter(u_id, u_type, city_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchstaffbypid(u_id, u_type) {
  try {
    const resp = await GetStaffByPid(u_id, u_type);
    if (resp.status == 1) return resp.data;
  } catch {
    return null;
  }
}

export async function fetchPrimeTrainingWebinarList(u_type) {
  try {
    const resp = await getAllPrimeTrainingWebinar(u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchPrimeNotificationList(u_type) {
  try {
    const resp = await getAllPrimeNotification(u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchPrimeAllPollList(u_type) {
  try {
    const resp = await getAllPrimePoll(u_type);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchPrimeMembershipFlowList() {
  try {
    const resp = await getPrimeMembershipFlowList();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchPrimeMagazineList() {
  try {
    const resp = await getPrimeMagazineList();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function GetAllPrimeMember() {
  try {
    const resp = await GetAllPrimeMemberList();
    return resp.data;
  } catch {
    return null;
  }
}

export async function getPrimeSuggestion(data) {
  try {
    const resp = await getPrimeSuggestionList(data);
    if (resp.status == 1) return resp.data;
    else return null;
  } catch (error) {
    return null;
  }
}

export async function fetchLvbsessionPodcastList() {
  try {
    const resp = await getAllLvbsessionPodcast();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchGreetingList() {
  try {
    const resp = await getAllPrimeGreeting();
    if (resp.status == 1) return resp.data;
    else return null;
  } catch {
    return null;
  }
}

export async function fetchPrimeMemberWelcomeKithistory(m_id) {
  try {
    const resp = await getPrimeMemberWelcomeKitHistory(m_id);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchPrimeDashboardCounter(u_id, u_type) {
  try {
    const resp = await getPrimeDashboardCounter(u_id, u_type);
    if (resp.status == 1) return resp?.data;
  } catch {
    return null;
  }
}

export async function fetchallcitylist() {
  try {
    const resp = await getAllCity();
    return resp.data;
  } catch {
    return null;
  }
}

export async function fetchallstatelist() {
  try {
    const resp = await getAllState();
    return resp;
  } catch {
    return null;
  }
}

export async function fetchallcountrylist() {
  try {
    const resp = await getAllCountry();
    return resp;
  } catch {
    return null;
  }
}
